/* @flow */
import enqueueIn from "./enqueueIn";

export default function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => enqueueIn(resolve, ms));
}



// WEBPACK FOOTER //
// ../nx-components/src/utils/sleep.js